import React, { useState } from "react";
import MaterialTable from "material-table";
import { Link } from "react-router-dom";
import tableIcons from "./IconsTable";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import OrderService from "../pages/order/RestService";
import { createBrowserHistory } from "history";
import ReactHtmlParser from "react-html-parser";
import CandleStickChart from "../pages/Chart/CandleStickChart";

const history = createBrowserHistory({
  forceRefresh: true,
});

export default function CustomTable(props) {
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  const mobile = userdata.mobile ? userdata.mobile : "";
  const web_token = userdata.web_token ? userdata.web_token : "";
  const redirectlink = props.redirectlink;
  let marketdata = props.marketdata ? props.marketdata : [];
  let pageSizeNumber = props.pageSizeNumber ? props.pageSizeNumber : 20;
  const [openOrder, setOpenOrder] = useState(false);
  const [openAuto, setOpenAuto] = useState(false);
  const [details, setDetails] = useState(false);
  const [submitDisabled, setsubmitDisabled] = useState(false);
  const [candlestick, setCandlestick] = useState([]);
  const [openChart, setOpenChart] = useState(false);
  const theme = useTheme();
  const isMob = useMediaQuery(theme.breakpoints.down("sm"));
  const customColumn = props.columndata;
  const suffix = props?.suffix;
  let column = [];
  const showchart = (candleData) => {
    setCandlestick(candleData);
    setOpenChart(true);
  };
  const handleChartClose = () => {
    setOpenChart(false);
  };
  if (customColumn) {
    customColumn?.forEach((item) => {
      if (item.dataField === "symbol") {
        const suffixText = suffix === true ? "" : "-share-price";
        column.push({
          title: item.text,
          field: item.dataField,
          render: (rowData) => (
            <Link
              to={redirectlink + rowData.symbol?.toLowerCase() + suffixText}
            >
              {rowData.symbol}{" "}
            </Link>
          ),
        });
      } else if (item.dataField === "chart") {
        column.push({
          title: item.text,
          field: item.dataField,
          render: (rowData) => (
            <div
              title="View chart"
              onClick={() => showchart(rowData.chart)}
              className="btn-sm btn-primary"
            >
              Chart
            </div>
          ),
        });
      } else if (item.dataField === "info") {
        column.push({
          title: item.text,
          field: item.dataField,
          render: (rowData) => (
            <i
              title="View Info"
              onClick={() => showInfo(rowData.info)}
              className="btn-sm fa fa-info btn-primary"
            ></i>
          ),
        });
      } else if (item.dataField === "counter") {
        column.push({
          title: item.text,
          field: item.dataField,
          render: (rowData) => (
            <button
              className="btn btn-sm btn-success"
              onClick={() => showAutoInfo(rowData.autoName)}
            >
              {rowData.counter}
            </button>
          ),
        });
      } else if (item.dataField === "orderAction") {
        column.push({
          title: item.text,
          field: item.dataField,
          render: (rowData) => (
            <>
              <Link
                to={`/order-dashboard/edit-strategy/${rowData.orderAction}`}
              >
                <i className="btn-sm fa fa-edit btn-primary mr-1"></i>
              </Link>
              <i
                onClick={() => showInfo(rowData.orderAction)}
                className="btn-sm  fa fa-trash btn-danger "
              ></i>
            </>
          ),
        });
      } else if (item.dataField === "orderId") {
        column.push({
          title: item.text,
          field: item.dataField,
          render: (rowData) => (
            <Link to={redirectlink + rowData.orderId}>{rowData.orderId} </Link>
          ),
        });
      } else if (item.dataField === "name") {
        column.push({
          title: item.text,
          field: item.dataField,
          render: (rowData) => rowData.name,
        });
      } else if (item.dataField === "cp") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.cp < 0 ? "txtRed" : "txtGreen"}>
              {rowData.cp}
            </span>
          ),
        });
      } else if (item.dataField === "prftLoss") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.prftLoss < 0 ? "txtRed" : "txtGreen"}>
              {rowData.prftLoss}
            </span>
          ),
        });
      } else if (item.dataField === "optionchainSignal") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span
              className={
                rowData.optionchainSignal === "Short BuildUp"
                  ? "txtRed"
                  : rowData.optionchainSignal === "Long Unwinding"
                  ? "cyanTxt"
                  : "txtGreen"
              }
            >
              {rowData.optionchainSignal}
            </span>
          ),
        });
      } else if (item.dataField === "currPrice") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.currPrice < 0 ? "txtRed" : "txtGreen"}>
              {rowData.currPrice}
            </span>
          ),
        });
      } else if (item.dataField === "per") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.per < 0 ? "txtRed" : "txtGreen"}>
              {rowData.per}
            </span>
          ),
        });
      } else if (item.dataField === "today") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.today < 0 ? "txtRed" : "txtGreen"}>
              {rowData.today}
            </span>
          ),
        });
      } else if (item.dataField === "pcontracts") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.pcontracts < 0 ? "txtRed" : "txtGreen"}>
              {rowData.pcontracts}
            </span>
          ),
        });
      } else if (item.dataField === "ltp") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.ltp < 0 ? "txtRed" : "txtGreen"}>
              {rowData.ltp}
            </span>
          ),
        });
      } else if (item.dataField === "t1") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.t1 < 0 ? "txtRed" : "txtGreen"}>
              {rowData.t1}
            </span>
          ),
        });
      } else if (item.dataField === "t2") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.t2 < 0 ? "txtRed" : "txtGreen"}>
              {rowData.t2}
            </span>
          ),
        });
      } else if (item.dataField === "close") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.close < 0 ? "txtRed" : "txtGreen"}>
              {rowData.close}
            </span>
          ),
        });
      } else if (item.dataField === "chg") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.chg < 0 ? "txtRed" : "txtGreen"}>
              {rowData.chg}
            </span>
          ),
        });
      } else if (item.dataField === "t3") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.t3 < 0 ? "txtRed" : "txtGreen"}>
              {rowData.t3}
            </span>
          ),
        });
      } else if (item.dataField === "weekpers") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.weekpers < 0 ? "txtRed" : "txtGreen"}>
              {rowData.weekpers}
            </span>
          ),
        });
      } else if (item.dataField === "onemonthpers") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.onemonthpers < 0 ? "txtRed" : "txtGreen"}>
              {rowData.onemonthpers}
            </span>
          ),
        });
      } else if (item.dataField === "threemonthpers") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span
              className={rowData.threemonthpers < 0 ? "txtRed" : "txtGreen"}
            >
              {rowData.threemonthpers}
            </span>
          ),
        });
      } else if (item.dataField === "sixmonthpers") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.sixmonthpers < 0 ? "txtRed" : "txtGreen"}>
              {rowData.sixmonthpers}
            </span>
          ),
        });
      } else if (item.dataField === "avvo") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.avvo < 0 ? "txtRed" : "txtGreen"}>
              {rowData.avvo}
            </span>
          ),
        });
      } else if (item.dataField === "chg_in_ol") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.chg_in_ol < 0 ? "txtRed" : "txtGreen"}>
              {rowData.chg_in_ol}
            </span>
          ),
        });
      } else if (item.dataField === "popen_int") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.popen_int < 0 ? "txtRed" : "txtGreen"}>
              {rowData.popen_int}
            </span>
          ),
        });
      } else if (item.dataField === "btintraday") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={"txtGreen"}>{rowData.btintraday}</span>
          ),
        });
      } else if (item.dataField === "stintraday") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={"txtRed"}>{rowData.stintraday}</span>
          ),
        });
      } else if (item.dataField === "option_type") {
        column.push({
          title: item.text,
          field: item.dataField,
          render: (rowData) => (
            <span
              className={rowData.option_type === "PE" ? "txtRed" : "txtGreen"}
            >
              {rowData.option_type}
            </span>
          ),
        });
      } else if (item.dataField === "change_in_oi") {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
          render: (rowData) => (
            <span className={rowData.change_in_oi < 0 ? "txtRed" : "txtGreen"}>
              {rowData.change_in_oi}
            </span>
          ),
        });
      } else if (item.dataField === "expiry_date") {
        column.push({ title: item.text, field: item.dataField });
      } else if (item.dataField === "update_time") {
        column.push({ title: item.text, field: item.dataField });
      } else if (item.dataField === "dtime") {
        column.push({ title: item.text, field: item.dataField });
      } else if (item.dataField === "date") {
        column.push({ title: item.text, field: item.dataField });
      } else if (item.dataField === "dateOne") {
        column.push({ title: item.text, field: item.dataField });
      } else if (item.dataField === "dateTwo") {
        column.push({ title: item.text, field: item.dataField });
      } else if (item.dataField === "time_stamp") {
        column.push({ title: item.text, field: item.dataField });
      } else if (item.dataField === "sectorName") {
        column.push({ title: item.text, field: item.dataField });
      } else if (item.dataField === "strategyType") {
        column.push({ title: item.text, field: item.dataField });
      } else if (item.dataField === "strategyName") {
        column.push({ title: item.text, field: item.dataField });
      } else if (item.dataField === "product") {
        column.push({ title: item.text, field: item.dataField });
      } else if (item.dataField === "signaltype") {
        column.push({ title: item.text, field: item.dataField });
      } else if (item.dataField === "signal") {
        column.push({
          title: item.text,
          field: item.dataField,
          render: (rowData) => (
            <span
              className={
                rowData.signal === "IntradaySell" ||
                rowData.signal === "JackpotSell" ||
                rowData.signal === "DnTrend" ||
                rowData.signal === "LongTSell" ||
                rowData.signal === "ShortTSell"
                  ? "txtRed"
                  : "txtGreen"
              }
            >
              {rowData.signal}
            </span>
          ),
        });
      } else {
        column.push({
          title: item.text,
          field: item.dataField,
          type: "numeric",
        });
      }
    });
  }

  const handleOrderClose = () => {
    setOpenOrder(false);
  };
  const handleAutoClose = () => {
    setOpenAuto(false);
  };

  const showInfo = (item) => {
    setDetails(item);
    setOpenOrder(true);
  };

  const showAutoInfo = (item) => {
    setDetails(item);
    setOpenAuto(true);
  };

  const handleDeleteOrder = () => {
    if (details) {
      setsubmitDisabled(true);
      OrderService.deleteOrderRecord(
        function (res) {
          history.push("/order-dashboard");
        },
        mobile,
        web_token,
        details
      );
    }
  };

  return (
    <>
      <Dialog
        open={openChart}
        onClose={handleChartClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {candlestick?.[0]?.symbol}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <CandleStickChart candlestick={candlestick} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button onClick={handleChartClose} className="btn-sm btn-success">
            Close
          </button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openAuto}
        onClose={handleAutoClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {ReactHtmlParser(details)}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button onClick={handleAutoClose} className="btn-sm btn-success">
            Close
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openOrder}
        onClose={handleOrderClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Remove Strategy"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p>Are you sure want to delete this?</p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button onClick={handleOrderClose} className="btn-sm btn-success">
            Close
          </button>

          {submitDisabled ? (
            <button className="btn-sm btn-danger">
              Please wait <i className="fa fa-spinner fa-spin"></i>
            </button>
          ) : (
            <button onClick={handleDeleteOrder} className="btn-sm btn-danger">
              Delete
            </button>
          )}
        </DialogActions>
      </Dialog>

      <div className="table-responsive manage-table">
        <MaterialTable
          className="newClass"
          options={{
            pageSize: parseInt(pageSizeNumber),
            pageSizeOptions: [5, 10, 20, 30, 50, 75, 100],
            toolbar: true,
            paging: true,
            fixedColumns: isMob
              ? {}
              : {
                  left: 1,
                  right: 0,
                },
          }}
          icons={tableIcons}
          title=""
          columns={column}
          data={marketdata}
        />
      </div>
    </>
  );
}
